import { Row, SortingRule } from "react-table";
import {
  ISectionType,
  ITableConfiguration,
  ITableType,
} from "../../../common/TablesConfiguration/tcConstants";

import { TableIncomingData } from "../../../models/Tables";
import { generalConst } from "../../../module/globalInterface";

export interface ITableProps {
  SODDeletedSummary?: boolean;
  dataSource: TableIncomingData[];
  rowsChangeable: boolean;
  showDetail?: boolean;
  showUserDetail?: boolean;
  showChekbox?: boolean;
  showBrInfo?: boolean;
  detailURL?: string;
  selectAll?: boolean;
  pageSizeProp?: number;
  changeLocation?: (url: string) => {};
  areRowDeletable?: boolean;
  onDeleteRow?: (id: string) => void;
  areRowEditable?: boolean;
  onEditRow?: (id: string) => {};
  areRowReplayable?: boolean;
  onReplay?: (id: string) => {};
  areRowDownloadable?: boolean;
  onDownloadRow?: (id: string) => {};
  onCheckboxChange?: Function;
  initialState?: {};
  showCTAButton?: boolean;
  initialSelectedUser?: Row<any>[];
  onCheckboxChangeEvent?: boolean;
  onDetailClick?: (row: any) => {};
  onUserDetailClick?: (row: any) => {};
  filterProps?: any;
  summaryDetail?: boolean;
  stopLoader?: () => {};
  violationOfVisibility?: boolean;
  temporary?: boolean;
  isBR?: boolean;
  onInfoBR?: (id: string) => {};
  isPassword?: boolean;
  onPasswordClick?: (id: string) => {};
  showWhiteAndBlack?: boolean;
  columnOrder?: string[];
  tableName?: string;
  onClickCSV?: () => void;
  CSVData?: any[];
  CSVDisabled?: boolean;
  CSVRef?: any;
  // PAGINATION
  serverSidePagination?: boolean;
  fetchData?: (
    pageIndex: number,
    pageSize: number,
    filterProps: any,
    sortBy?: SortingRule<{}>[]
  ) => {};
  pageCount?: number;
  pageIndexProp?: number;
  totalElements?: number;
  sectionType?: ISectionType;
  tableType?: ITableType;
  tablesConfiguration: ITableConfiguration[];
  showUnlock?: boolean;
  showReset?: boolean;
  showChange?: boolean;
  showBlock?: boolean;
  onUnlockRow?: (row: any) => {};
  onResetRow?: (row: any) => {};
  onChangeRow?: (row: any) => {};
  onBlockRow?: (row: any) => {};
  serverSideSorting?: boolean;
  sortByProp?: SortingRule<{}>[];
}

export const hideColumns: generalConst = {
  attributeId: "attributeId",
  id_user: "id_user",
  available: "available",
  resp_code: "resp_code",
  validable: "validable",
  editable: "editable",
  entitlement_id: "entitlement_id",
  entitlementIdentityId: "entitlementIdentityId",
  monoProfilo: "monoProfilo",
  isMonoprofilo: "isMonoprofilo",
  isCritical: "isCritical",
  bao: "bao",
  phoneNumber: "phoneNumber",
  mobileNumber: "mobileNumber",
  mobileNumberVerified: "mobileNumberVerified",
  identity_system_id: "identity_system_id",
  showOnFrontend: "showOnFrontend",
  showOnFrontEnd: "showOnFrontEnd",
  company: "company",
  beneficiaryCompany: "beneficiaryCompany",
  applicantCompany: "applicantCompany",
  application_id: "application_id",
  internal_id: "internal_id",
  entitlements: "entitlements",
  parent_id: "parent_id",
  parentId: "parentId",
  hide_status: "hide_status",
  hidedNote: "hidedNote",
  organizational_unit_code: "organizational_unit_code",
  beneficiary_id: "beneficiary_id",
  delegation_id: "delegation_id",
  chainEntitlements: "chainEntitlements",
  chainEntitlementsIds: "chainEntitlementsIds",
  sections: "sections",
  roles: "roles",
  admin_role_required: "admin_role_required",
  violationOfVisibility: "violationOfVisibility",
  temporary: "temporary",
  added: "added",
  deleted: "deleted",
  uniqueId: "uniqueId",
  beneficiary_email: "beneficiary_email",
  task_id: "task_id",
  actionCode: "actionCode",
  comment: "comment",
  isBR: "isBR",
  codeBusinessRole: "codeBusinessRole",
  baoFullName: "baoFullName",
  adminRoleRequired: "adminRoleRequired",
  br_id: "br_id",
  BR_ID: "BR_ID",
  brId: "brId",
  supervisors: "supervisors",
  perimeter: "perimeter",
  operationExecuted: "operationExecuted",
  include: "include",
  certificationItemTypology: "certificationItemTypology",
  certificationItemId: "certificationItemId",
  user_id: "user_id",
  user_code: "user_code",
  hidden_enrichment_id: "hidden_enrichment_id",
  // identitySystemId: "identitySystemId",
  deleteAllowed: "deleteAllowed",
  attachId: "attachId",
  entitlementId: "entitlementId",
  campaignId: "campaignId",
  applicationId: "applicationId",
  businessRole: "businessRole",
  businessRoles: "businessRoles",
  itemId: "itemId",
  revisorCode: "revisorCode",
  idProperty: "idProperty",
  dynamicRole: "dynamicRole",
  properties: "properties",
  language: "language",
  referrer: "referrer",
  fullname: "fullname",
  completedItems: "completedItems",
  totalItems: "totalItems",
  // tiCode: "tiCode",
  tuAllowed: "tuAllowed",
  tuAccountId: "tuAccountId",
  _changePasswordAllowed: "_changePasswordAllowed",
  _resetPasswordAllowed: "_resetPasswordAllowed",
  _mfaRequired: "_mfaRequired",
  _securityQuestionsRequired: "_securityQuestionsRequired",
  _uigpOTPRequired: "_uigpOTPRequired",
  visibilityCone: "visibilityCone",
  // --- SOD MODAL ---
  involvedInSOD: "involvedInSOD",
  isInvolvedInSod: "isInvolvedInSod",
  sodConflictId: "sodConflictId",
  inputEntitlementId: "inputEntitlementId",
  inputEntitlementIdentitySystemId: "inputEntitlementIdentitySystemId",
  conflictEntitlementId: "conflictEntitlementId",
  conflictEntitlementIdentitySystemId: "conflictEntitlementIdentitySystemId",
  security_allowed: "security_allowed",
  mf_allowed: "mf_allowed",
  uigp_allowed: "uigp_allowed",
  operation: "operation",
  to: "to",
  cc: "c",
  ccn: "ccn",
  body: "body",
  retry_delay: "retry_delay",
  propagationId: "propagation_id",
  idRole: "idRole",
  sodManagementInputEntitlementDescription:
    "sodManagementInputEntitlementDescription",
  sodManagementInputApplicationDescription:
    "sodManagementInputApplicationDescription",
  sodManagementCheckEntitlementDescription:
    "sodManagementCheckEntitlementDescription",
  sodManagementCheckApplicationDescription:
    "sodManagementCheckApplicationDescription",
  consoleAdminProfilesManagementVisibility:
    "consoleAdminProfilesManagementVisibility",
  statusIdExternalPortal: "statusIdExternalPortal",
  idExternalPortal: "idExternalPortal",
  whitelist: "whitelist",
  enrichmentCode: "enrichmentCode",
  flag: "flag",
};

export const hideCells: generalConst = {
  ATTRIBUTEID: "ATTRIBUTEID",
  ID_USER: "ID_USER",
  AVAILABLE: "AVAILABLE",
  RESP_CODE: "RESP_CODE",
  VALIDABLE: "VALIDABLE",
  EDITABLE: "EDITABLE",
  ENTITLEMENT_ID: "ENTITLEMENT_ID",
  ENTITLEMENTIDENTITYID: "ENTITLEMENTIDENTITYID",
  MONOPROFILO: "MONOPROFILO",
  ISMONOPROFILO: "ISMONOPROFILO",
  ISCRITICAL: "ISCRITICAL",
  BAO: "BAO",
  IDENTITY_SYSTEM_ID: "IDENTITY_SYSTEM_ID",
  SHOWONFRONTEND: "SHOWONFRONTEND",
  PHONENUMBER: "PHONENUMBER",
  MOBILENUMBER: "  MOBILENUMBER",
  MOBILENUMBERVERIFIED: "  MOBILENUMBERVERIFIED",
  COMPANY: "COMPANY",
  BENEFICIARYCOMPANY: "BENEFICIARYCOMPANY",
  APPLICANTCOMPANY: "APPLICANTCOMPANY",
  APPLICATION_ID: "APPLICATION_ID",
  INTERNAL_ID: "INTERNAL_ID",
  ENTITLEMENTS: "ENTITLEMENTS",
  PARENT_ID: "PARENT_ID",
  PARENTID: "PARENTID",
  HIDE_STATUS: "HIDE_STATUS",
  HIDEDNOTE: "HIDEDNOTE",
  ORGANIZATIONAL_UNIT_CODE: "ORGANIZATIONAL_UNIT_CODE",
  BENEFICIARY_ID: "BENEFICIARY_ID",
  DELEGATION_ID: "DELEGATION_ID",
  CHAINENTITLEMENTS: "CHAINENTITLEMENTS",
  CHAINENTITLEMENTSIDS: "CHAINENTITLEMENTSIDS",
  SECTIONS: "SECTIONS",
  ROLES: "ROLES",
  ADMIN_ROLE_REQUIRED: "ADMIN_ROLE_REQUIRED",
  BR_ID: "BR_ID",
  BRID: "BRID",
  VIOLATIONOFVISIBILITY: "VIOLATIONOFVISIBILITY",
  ADDED: "ADDED",
  DELETED: "DELETED",
  UNIQUEID: "UNIQUEID",
  BENEFICIARY_EMAIL: "BENEFICIARY_EMAIL",
  TASK_ID: "TASK_ID",
  ACTIONCODE: "ACTIONCODE",
  COMMENT: "COMMENT",
  ISBR: "ISBR",
  CODEBUSINESSROLE: "CODEBUSINESSROLE",
  BAOFULLNAME: "BAOFULLNAME",
  ADMINROLEREQUIRED: "ADMINROLEREQUIRED",
  SUPERVISORS: "SUPERVISORS",
  PERIMETER: "PERIMETER",
  OPERATIONEXECUTED: "OPERATIONEXECUTED",
  INCLUDE: "INCLUDE",
  CERTIFICATIONITEMTYPOLOGY: "CERTIFICATIONITEMTYPOLOGY",
  CERTIFICATIONITEMID: "CERTIFICATIONITEMID",
  USER_ID: "USER_ID",
  USER_CODE: "USER_CODE",
  HIDDEN_ENRICHMENT_ID: "HIDDEN_ENRICHMENT_ID",
  // TICODE: "TICODE",
  TUALLOWED: "TUALLOWED",
  TUACCOUNTID: "TUACCOUNTID",
  VISIBILITYCONE: "VISIBILITYCONE",
  _CHANGEPASSWORDALLOWED: "_CHANGEPASSWORDALLOWED",
  _RESETPASSWORDALLOWED: "_RESETPASSWORDALLOWED",
  _MFAREQUIRED: "_MFAREQUIRED",
  _SECURITYQUESTIONSREQUIRED: "_SECURITYQUESTIONSREQUIRED",
  _UIGPOTPREQUIRED: "_UIGPOTPREQUIRED",
  // IDENTITYSYSTEMID: "IDENTITYSYSTEMID",
  DELETEALLOWED: "DELETEALLOWED",
  ATTACHID: "ATTACHID",
  ENTITLEMENTID: "ENTITLEMENTID",
  CAMPAIGNID: "CAMPAIGNID",
  APPLICATIONID: "APPLICATIONID",
  BUSINESSROLE: "BUSINESSROLE",
  BUSINESSROLES: "BUSINESSROLES",
  ITEMID: "ITEMID",
  REVISORCODE: "REVISORCODE",
  DYNAMICROLE: "DYNAMICROLE",
  PROPERTIES: "PROPERTIES",
  LANGUAGE: "LANGUAGE",
  REFERRER: "REFERRER",
  FULLNAME: "FULLNAME",
  COMPLETEDITEMS: "COMPLETEDITEMS",
  TOTALITEMS: "TOTALITEMS",
  // --- SOD MODAL ---
  SODCONFLICTID: "SODCONFLICTID",
  INPUTENTITLEMENTID: "INPUTENTITLEMENTID",
  INPUTENTITLEMENTIDENTITYSYSTEMID: "INPUTENTITLEMENTIDENTITYSYSTEMID",
  CONFLICTENTITLEMENTID: "CONFLICTENTITLEMENTID",
  CONFLICTENTITLEMENTIDENTITYSYSTEMID: "CONFLICTENTITLEMENTIDENTITYSYSTEMID",
  INVOLVEDINSOD: "INVOLVEDINSOD",
  ISINVOLVEDINSOD: "ISINVOLVEDINSOD",
  SECURITY_ALLOWED: "SECURITY_ALLOWED",
  MF_ALLOWED: "MF_ALLOWED",
  UIGP_ALLOWED: "UIGP_ALLOWED",
  OPERATION: "OPERATION",
  TEMPORARY: "TEMPORARY",
  TO: "TO",
  CC: "CC",
  CCN: "CCN",
  BODY: "BODY",
  RETRY_DELAY: "RETRY_DELAY",
  PROPAGATIONID: "PROPAGATIONID",
  IDROLE: "IDROLE",
  SODMANAGEMENTINPUTENTITLEMENTDESCRIPTION:
    "SODMANAGEMENTINPUTENTITLEMENTDESCRIPTION",
  SODMANAGEMENTINPUTAPPLICATIONDESCRIPTION:
    "SODMANAGEMENTINPUTAPPLICATIONDESCRIPTION",
  SODMANAGEMENTCHECKENTITLEMENTDESCRIPTION:
    "SODMANAGEMENTCHECKENTITLEMENTDESCRIPTION",
  SODMANAGEMENTCHECKAPPLICATIONDESCRIPTION:
    "SODMANAGEMENTCHECKAPPLICATIONDESCRIPTION",
  CONSOLEADMINPROFILESMANAGEMENTVISIBILITY:
    "CONSOLEADMINPROFILESMANAGEMENTVISIBILITY",
  STATUSIDEXTERNALPORTAL: "STATUSIDEXTERNALPORTAL",
  IDEXTERNALPORTAL: "IDEXTERNALPORTAL",
  WHITELIST: "WHITELIST",
  ENRICHMENTCODE: "ENRICHMENTCODE",
  FLAG: "FLAG",
};
